module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-heading-atami-91bfac4ac57651ed80b878aa15ad77d4.svg";